import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedAddons: [],
  addOnInfo: {},
  loading: false,
  errorMsg: {},
  isModalOpen: false,
  continueAddon: false,
  isAutoScroll: false,
};

export const PDPAddOn = createSlice({
  name: "addOn",
  initialState,
  reducers: {
    pdpAddOnModalVisibility: (state, action) => {
      return {
        ...state,
        isModalOpen: action?.payload,
        continueAddon: action?.payload === false ? false : state.continueAddon,
      };
    },
    handlePdpSelectedAddon: (state, action) => {
      return {
        ...state,
        selectedAddons: action.payload,
      };
    },

    requestToFetchPdpAddOnInfoAction: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    requestToFetchPdpAddOnInfoNewAction: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    successToFetchPdpAddOnInfoAction: (state, action) => {
      return {
        ...state,
        loading: false,
        addOnInfo: action.payload,
      };
    },
    resetPdpAddOnState: (state) => {
      return {
        ...state,
        selectedAddons: [],
        addOnInfo: {},
      };
    },
    // Clears only the selection, keeping addOnInfo intact so the PDP Addons section stays visible.
    resetPdpSelectedAddons: (state) => {
      return {
        ...state,
        selectedAddons: [],
        continueAddon: false,
      };
    },
    addAddonToCartPDPAction: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    successAddonToCartPDPAction: (state) => {
      return {
        ...state,
        loading: false,
        continueAddon: true,
      };
    },
    addPdpOrderSeqId: (state, action) => {
      return {
        ...state,
        addOnInfo: {
          ...state.addOnInfo,
          orderItemSeqId: action.payload,
        },
      };
    },
    setAutoScroll: (state, action) => {
      return {
        ...state,
        isAutoScroll: action.payload,
      };
    },
  },
});

export default PDPAddOn.reducer;
export const {
  pdpAddOnModalVisibility,
  handlePdpSelectedAddon,
  requestToFetchPdpAddOnInfoAction,
  successToFetchPdpAddOnInfoAction,
  resetPdpAddOnState,
  resetPdpSelectedAddons,
  addAddonToCartPDPAction,
  successAddonToCartPDPAction,
  addPdpOrderSeqId,
  setAutoScroll,
  requestToFetchPdpAddOnInfoNewAction,
} = PDPAddOn.actions;
